import { forwardRef } from 'react';

interface WeatherIconProps extends React.SVGProps<SVGSVGElement> {
  size?: 'small' | 'medium' | 'large';
}

const ICON_SIZES = {
  small: 20,
  medium: 24,
  large: 32,
};

const WeatherIcon = forwardRef<SVGSVGElement, WeatherIconProps>(
  ({ size = 'medium', ...props }, ref) => {
    const iconSize = ICON_SIZES[size];

    return (
      <svg
        id='weather_incident'
        xmlns='http://www.w3.org/2000/svg'
        width={iconSize}
        height={iconSize}
        viewBox='0 0 24 25'
        ref={ref}
        {...props}
      >
        <g id='Group_339' data-name='Group 339'>
          <rect
            id='Rectangle_7'
            data-name='Rectangle 7'
            width='24'
            height='24'
            fill='rgba(255,255,255,0.87)'
            opacity='0'
          />
        </g>
        <g id='Group_341' data-name='Group 341'>
          <g id='Group_340' data-name='Group 340'>
            <path
              id='Path_51'
              data-name='Path 51'
              d='M0,0H2V8L0,6.728Z'
              transform='translate(18 4)'
            />
            <rect
              id='Rectangle_9'
              data-name='Rectangle 9'
              width='2'
              height='16'
              transform='translate(4 4)'
            />
            <rect
              id='Rectangle_10'
              data-name='Rectangle 10'
              width='2'
              height='4'
              transform='translate(11 4)'
            />
            <path
              id='Path_52'
              data-name='Path 52'
              d='M0,0H2V.928L0,2.5Z'
              transform='translate(11 10)'
            />
          </g>
        </g>
        <g id='cloud_queue-24px' transform='translate(14 15)'>
          <path id='Path_45' data-name='Path 45' d='M0,0H10V10H0Z' fill='none' />
          <path
            id='Path_46'
            data-name='Path 46'
            d='M13.168,8.11A5.1,5.1,0,0,0,3.641,6.749a4.081,4.081,0,0,0,.442,8.139H12.93a3.393,3.393,0,0,0,.238-6.778Zm-.238,5.417H4.083a2.722,2.722,0,1,1,0-5.444h.483A3.742,3.742,0,0,1,11.909,9.1v.34H12.93a2.042,2.042,0,1,1,0,4.083Z'
            transform='translate(-6.333 -6.555)'
          />
        </g>
      </svg>
    );
  }
);

export default WeatherIcon;
